import * as $ from "jquery";
import imkt from '../../../imkt';
import tracking from '../../../utils/tracking';

class Stack {
  cards: HTMLCollection;
  cardsTotal: any;
  visibleCards: number;
  cardSpacing: number;
  current: number = 0;

  constructor(element: HTMLElement) {
    this.cards = element.children;
    this.cardsTotal = this.cards.length;

    this.visibleCards = 2;
    this.cardSpacing = -50;

    // set default perspective
    element.style.WebkitPerspective = element.style.perspective = "1000px";
    element.style.WebkitPerspectiveOrigin = element.style.perspectiveOrigin =
      "50% -50%";

    this._init();
  }

  _init() {
    this.setProgress(this.current);
    this.enableKeyboard(this.currentCard());
  
    // set default styles on the cards in the stack
    for (var i = 0; i < this.cardsTotal; i++) {
      var card = this.cards[i];
  
      // set z-index high and in decreasing order to form card stack
      card.style.zIndex =
        i === 0 ? this.visibleCards + 101 : this.visibleCards + 100 - i;
      if (i < this.visibleCards) {
        card.style.visibility = "visible";
        card.style.pointerEvents = "auto";
        card.style.WebkitTransform = card.style.transform =
          "translate3d(0px, 0px, " + this.cardSpacing * i + "px)";
      } else {
        card.style.visibility = "hidden";
        card.style.pointerEvents = "none";
        card.style.WebkitTransform = card.style.transform =
          "translate3d(0px, 0px, " + this.cardSpacing * this.visibleCards + "px)";
      }
    }
  
    $(this.currentCard()).addClass("stack__item--current");
  }

  currentCard() {
    return this.cards[this.current];
  }

  enableKeyboard(card) {
    $(card).find(".field-type-checkbox").attr("tabindex", "0");
    $(card)
      .find(".field-type-checkbox")
      .on("keypress", function (e) {
        if (e.which == 13) {
          $(this).find("input[type='checkbox']").prop("checked", true);
          $(this).trigger("change");
        }
      });
  }

  disableKeyboard(card) {
    $(card).find(".field-type-checkbox").removeAttr("tabindex");
    $(card).find(".field-type-checkbox").off("keypress");
  }

  restart() {
    // hide accordion and added classes, then re-initialize
    $(".block--outcome, .block--accordions, .accordion").hide();
    $('input[type="checkbox"]').attr("checked", false);
    $(".field-type-checkbox").removeClass("box-checked");
    $(".stack__item").removeClass("stack__item--current");
    this._init();
  }

  setProgress(value) {
    $("#progress-bar").animate(
      {
        width: value * 10 + "%",
      },
      500
    );
  }

  onEndAnimation(element, callback) {
    var onEndCallbackFn = function () {
      this.removeEventListener("animationend", onEndCallbackFn);
      callback();
    };
    element.addEventListener("animationend", onEndCallbackFn);
  }

  back() {
    var currentCard = this.currentCard();
    var previousCard = this.cards[this.current - 1];
    var nextCard = this.cards[this.current + 1];
  
    // remove next card from the visible stack
    nextCard.style.visibility = "hidden";
  
    // prepare current card to be the next card
    this.disableKeyboard(currentCard);
    $(currentCard).removeClass("stack__item--current");
  
    // prepare previous card to be the current card
    previousCard.style.pointerEvents = "auto";
    previousCard.style.visibility = "visible";
    $(previousCard).addClass("stack__item--back");
  
    this.onEndAnimation(previousCard, function () {
      $(previousCard).removeClass("stack__item--back");
    });
  
    // set style for the visible cards
    for (var i = 0; i < this.cardsTotal; i++) {
      if (i >= this.visibleCards) break;
      if (this.current - 1 + i >= this.cardsTotal - 1) break;
      var pos = this.current - 1 + i;
      var card = this.cards[pos];
      card.style.pointerEvents = "auto";
      card.style.visibility = "visible";
    }
  
    // update current card and progress
    this.current = this.current < this.cardsTotal - 1 ? this.current - 1 : 0;
    this.setProgress(this.current);
    this.enableKeyboard(this.currentCard());
    $(this.currentCard()).addClass("stack__item--current");
  }

  next() {
    var currentCard = this.currentCard();
  
    // hide current card through animation
    this.disableKeyboard(currentCard);
    $(currentCard).removeClass("stack__item--current");
    $(currentCard).addClass("stack__item--next");
  
    this.onEndAnimation(currentCard, function () {
      // reset current card
      currentCard.style.visibility = "hidden";
      currentCard.style.pointerEvents = "none";
  
      $(currentCard).removeClass("stack__item--next");
    });
  
    // set style for the visible cards
    var card;
    for (var i = 0; i < this.cardsTotal; i++) {
      if (i >= this.visibleCards) break;
      if (this.current + i >= this.cardsTotal - 1) break;
      var pos = this.current + i + 1;
  
      card = this.cards[pos];
      card.style.pointerEvents = "auto";
      card.style.visibility = "visible";
    }
  
    // animate visible cards
    for (i = 0; i < this.cardsTotal; i++) {
      if (this.currentCard < i < this.visibleCards + this.currentCard) {
        card.style.WebkitTransform = card.style.transform =
          "translate3d(0px, 0px, " + this.cardSpacing * i + "px)";
      } else {
        card.style.WebkitTransform = card.style.transform =
          "translate3d(0px, 0px, " + this.cardSpacing * this.visibleCards + "px)";
      }
    }
  
    // update current card and progress
    this.current = this.current < this.cardsTotal - 1 ? this.current + 1 : 0;
    this.setProgress(this.current);
    this.enableKeyboard(this.currentCard());
    $(this.currentCard()).addClass("stack__item--current");
  }
}

// @ts-ignore
window.Stack = Stack;

imkt.landing.MaturityModel = class MaturityModel {
  $domRoot: JQuery<HTMLElement> = $("body");
  $booleanCheckboxes: JQuery<HTMLElement> = $(".field-type-checkbox", this.$domRoot);
  $inputTypeCheckbox: JQuery<HTMLElement> = $(
    "input[type='checkbox']",
    this.$booleanCheckboxes
  );
  $selectSize: JQuery<HTMLElement> = $("select[name='size']");
  $selectTeam: JQuery<HTMLElement> = $("select[name='team']");
  answersObject: Object = this.resetAnswers();;
  cardStack: Stack = new Stack(document.getElementById("card-stack"));;

  constructor() {
    if ($("body").hasClass("edit")) {
      return;
    }

    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    var self = this;

    this.$booleanCheckboxes.on("input change", function () {
      var $this = $(this);

      // Make checkboxes behave like radio buttons
      $this
        .siblings(self.$booleanCheckboxes)
        .find(self.$inputTypeCheckbox)
        .prop("checked", false);
      $this.find(self.$inputTypeCheckbox).prop("checked", true);

      self.enableButton($this);
      self.styleCheckedBox();
      self.removeError();
    });

    $(".field-type-checkbox").on("click", function () {
      $(this).trigger("change");
    });

    $(".field-type-checkbox").on("keypress", function (e) {
      if (e.which == 13) {
        $(this).trigger("change");
      }
    });

    $(".start-survey").on("click", function () {
      self.cardStack.next();
      return false;
    });

    $(".next").on("click", function () {
      if (self.isBoxChecked(this)) {
        var currentQuestionNumber = $(this).data("custom");
        self.scoreQuestion(currentQuestionNumber, self.getAnswer(this));
        self.cardStack.next();
      } else {
        self.addError(this);
      }
      return false;
    });

    $(".back").on("click", function () {
      var currentQuestionNumber = $(this).data("custom");
      self.scoreQuestion(currentQuestionNumber, null);
      self.cardStack.back();
      return false;
    });

    $(".finish").on("click", function () {
      if (self.isBoxChecked(this)) {
        var currentQuestionNumber = $(this).data("custom");
        var totalScore = 0;
        self.scoreQuestion(currentQuestionNumber, self.getAnswer(this));
        Object.keys(self.answersObject).forEach(function (question) {
          totalScore += self.answersObject[question];
        });
        self.displayResults(totalScore);
        self.cardStack.next();
      } else {
        self.addError(this);
      }
      return false;
    });

    $(".retake-survey").on("click", function () {
      self.answersObject = self.resetAnswers();
      self.cardStack.restart();
      return false;
    });

    $(".facebook a").on("click", function () {
      tracking.trackEvent("clicked button social share", {
        social_type: "facebook",
      });
    });

    $(".twitter a").on("click", function () {
      tracking.trackEvent("clicked button social share", {
        social_type: "twitter",
      });
    });
  }

  getQuestion(number: number) {
    return $("div[data-custom=" + "'" + number + "'" + "]");
  }

  getTeamAndSize() {
    this.answersObject["team"] = this.$selectTeam.val();
    this.answersObject["size"] = this.$selectSize.val();
  }

  getAnswer(button: HTMLElement) {
    return $(button)
      .parents(".card-block")
      .find("input[type='checkbox']:checked")
      .data("custom");
  }

  scoreQuestion(questionNumber: number, questionScore: number) {
    this.answersObject["devops_question_" + questionNumber] = questionScore;
  }

  isBoxChecked(button: HTMLElement) {
    return $(button)
      .parents(".card-block")
      .find("input[type='checkbox']:checked")
      .prop("checked");
  }

  styleCheckedBox() {
    $("input[type='checkbox']:checked")
      .parents(".field-type-checkbox")
      .addClass("box-checked");
    $("input:checkbox:not(:checked)")
      .parents(".field-type-checkbox")
      .removeClass("box-checked");
  }

  enableButton(button: HTMLElement) {
    $(button)
      .parents(".card-block")
      .find(".next, .finish")
      .removeClass("disabled-button");
  }

  addError(button: HTMLElement) {
    if (!this.isBoxChecked(button)) {
      $(button)
        .parents(".card-block")
        .find(".field-type-checkbox")
        .addClass("form-error");
      $(button)
        .parents(".card-block")
        .find(".error-message")
        .css("display", "flex");
    }
  }

  removeError() {
    $(".field-type-checkbox").removeClass("form-error");
    $(".error-message").hide();
  }

  displayResults(totalScore: number) {
    $(".block--accordions").show();
    if (totalScore >= 10 && totalScore <= 14) {
      this.buildResults("base");
    } else if (totalScore >= 15 && totalScore <= 24) {
      this.buildResults("beginner");
    } else if (totalScore >= 25 && totalScore <= 34) {
      this.buildResults("intermediate");
    } else if (totalScore >= 35 && totalScore <= 44) {
      this.buildResults("advanced");
    } else {
      this.buildResults("expert");
    }
    this.getTeamAndSize();
    tracking.trackEvent("clicked button finish", this.answersObject);
  }

  resultsMapping() {
    return {
      base: {
        "accordion-level": ".accordion--base",
        "result-level": ".block--outcome-base",
      },
      beginner: {
        "accordion-level": ".accordion--beginner",
        "result-level": ".block--outcome-beginner",
      },
      intermediate: {
        "accordion-level": ".accordion--intermediate",
        "result-level": ".block--outcome-intermediate",
      },
      advanced: {
        "accordion-level": ".accordion--advanced",
        "result-level": ".block--outcome-advanced",
      },
      expert: {
        "accordion-level": ".accordion--expert",
        "result-level": ".block--outcome-expert",
      },
    };
  }

  buildResults(level: number) {
    Object.keys(this.resultsMapping()).forEach(
      function (item) {
        if (level === item) {
          $(this.resultsMapping()[item]["result-level"]).show();
        } else {
          $(this.resultsMapping()[item]["accordion-level"]).show();
        }
      }.bind(this)
    );
    return this.scrollToResult(this.resultsMapping()[level]["result-level"]);
  }

  scrollToResult(result: string) {
    $("html, body").animate({ scrollTop: $(result).offset().top }, "slow");
  }

  resetAnswers() {
    return {
      devops_question_1: null,
      devops_question_2: null,
      devops_question_3: null,
      devops_question_4: null,
      devops_question_5: null,
      devops_question_6: null,
      devops_question_7: null,
      devops_question_8: null,
      devops_question_9: null,
      devops_question_10: null,
    };
  }
}

new imkt.landing.MaturityModel();
